import React, { useState } from 'react';

import PropTypes from 'prop-types';
import { Segment, Button } from 'semantic-ui-react';

import { QuestionType } from 'components/modules/questions/types';

import { filterQuestions } from './AvailableQuestionsList.utils';
import QuestionListFilter from './components/QuestionListFilter';

import './AvailableQuestionsList.scss';

const propTypes = {
  questions: PropTypes.arrayOf(QuestionType).isRequired,
  onAdd: PropTypes.func.isRequired,
};

const defaultProps = {};

export default function AvailableQuestionsList({ questions, onAdd }) {
  const [filterText, setFilterText] = useState('');

  const filteredQuestions = filterQuestions(questions, filterText);

  return (
    <>
      <QuestionListFilter value={filterText} onChange={setFilterText} />
      <div className="available-questions-list">
        {filteredQuestions.map((question) => (
          <Segment key={question.id} className="available-question-item">
            <div className="question-content">
              <div className="question-text">{question.text}</div>
              <Button
                className="action-button compact"
                icon="plus"
                onClick={() => onAdd(question.id)}
                title="Add to group"
              />
            </div>
          </Segment>
        ))}
      </div>
    </>
  );
}

AvailableQuestionsList.propTypes = propTypes;
AvailableQuestionsList.defaultProps = defaultProps;
